import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private _token = signal<string>('');
  private _userName = signal<string>('');

  readonly token = this._token.asReadonly();
  readonly userName = this._userName.asReadonly();

  setToken(token: string): void {
    this._token.set(token);
    // Use the localStorage key as for token sharing
    localStorage.setItem('cc_js_token_lp', token);
  }

  setUserName(userName: string): void {
    this._userName.set(userName);
    localStorage.setItem('cc_current_user_lp', userName);
  }

  loadToken(): void {
    // Load from the same localStorage key as lp-installation-agent for token sharing
    const token = localStorage.getItem('cc_js_token_lp');
    if (token) {
      this._token.set(token);
    }

    const userName = localStorage.getItem('cc_current_user_lp');
    if (userName) {
      this._userName.set(userName);
    }
  }

  clearToken(): void {
    this._token.set('');
    this._userName.set('');
    localStorage.removeItem('cc_js_token_lp');
    localStorage.removeItem('cc_current_user_lp');
  }
}
